/**
 * Adds the query param translation_wrapping=true to all link if it is set in the address bar.
 */
(function (window, document, $) {
	'use strict';
	if (/[?&]translation_wrapping=/.test( location.search )) {
		var query_string = 'translation_wrapping=true';
		$( 'a' ).each(
			function() {
				var href = encodeURI($( this ).attr( 'href' ));
				// Safety check for is the <a> tag actually has a "href" of if it is just an anchor on the page.
				if (href) {
					// Account for anchors in links
					var maybe_anchor = href.split( '#' );
					href             = maybe_anchor[0];
					var anchor       = maybe_anchor[1];
					href            += ( href.match( /\?/ ) ? '&' : '?' ) + query_string + ( anchor !== undefined ? '#' + anchor : '' );
					$( this ).attr( 'href', href );
				}
			}
		);
	}
})( window, document, jQuery );
